export const dynamicDemoParamTypes = {
    QuestionCode: 0,
	ProgramTitle: 1,
	Channel: 2
}